var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#1185FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100424_215100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6922 13.8895C11.8532 14.0035 12.0607 14.032 12.2457 13.962C12.4307 13.8915 12.5667 13.7335 12.6077 13.542C13.0422 11.5 14.0962 6.33145 14.4917 4.47395C14.5217 4.33395 14.4717 4.18845 14.3617 4.09495C14.2517 4.00145 14.0992 3.97445 13.9632 4.02495C11.8667 4.80095 5.4102 7.22345 2.7712 8.19995C2.6037 8.26195 2.4947 8.42295 2.5002 8.59945C2.5062 8.77645 2.6252 8.92995 2.7967 8.98145C3.9802 9.33545 5.5337 9.82795 5.5337 9.82795C5.5337 9.82795 6.2597 12.0205 6.6382 13.1355C6.6857 13.2755 6.7952 13.3855 6.9397 13.4235C7.0837 13.461 7.2377 13.4215 7.3452 13.32C7.9532 12.746 8.8932 11.8585 8.8932 11.8585C8.8932 11.8585 10.6792 13.168 11.6922 13.8895ZM6.1872 9.55095L7.0267 12.32L7.2132 10.5665C7.2132 10.5665 10.4567 7.64095 12.3057 5.97345C12.3597 5.92445 12.3672 5.84245 12.3222 5.78495C12.2777 5.72745 12.1957 5.71395 12.1342 5.75295C9.9912 7.12145 6.1872 9.55095 6.1872 9.55095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100424_215100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.85d34290b785ca7780ccc8390b65a184.svg";
export { ForwardRef as ReactComponent };